<template>
    <AppChartWrapper
        imageName="Topic Cloud"
        :hideIcon="true"
    >
        <h4 slot="title" class="subheading text-xs-left font-weight-regular section-title--color">{{ name | unescapeString }}</h4>
        <v-layout v-if="summaryDataReady" slot="chart" row wrap>
            <v-flex mb-5 text-xs-center xs12>
                <TopicCloudCustomFilter v-model="wordCloudSentimentValues" value="positive">positive</TopicCloudCustomFilter>
                <TopicCloudCustomFilter v-model="wordCloudSentimentValues" value="negative">negative</TopicCloudCustomFilter>
                <TopicCloudCustomFilter v-model="wordCloudSentimentValues" value="neutral">neutral</TopicCloudCustomFilter>
                <TopicCloudCustomFilter v-model="wordCloudSentimentValues" value="interest">interest</TopicCloudCustomFilter>
            </v-flex>
            <v-flex xs12>
                <vue-word-cloud
                        :color="(word) => {
                                                    return {
                                                    'positive': '#1AB177',
                                                    'negative': '#EB2929',
                                                    'neutral': '#EAC82A',
                                                    'interest': '#1F65C5'
                                                    }[word.category]
                                                    }"
                        :words="wordsCloudData.data"
                        font-family="Roboto"
                        style="min-width: 400px; min-height: 350px; margin-top: -25px;"
                        v-if="wordsCloudData.data.length > 0"
                ></vue-word-cloud>
                <div class="text-xs-center d-flex fill-height align-center" style="height: 325px" v-else>
                    <span class="font-weight-bold display-1" style="color:#AFBAC8">Topic Cloud Data Not Found</span>
                </div>
            </v-flex>
        </v-layout>
    </AppChartWrapper>
</template>

<script>
	import VueWordCloud from "vuewordcloud";
	import TopicCloudCustomFilter from "./TopicCloudCustomFilter";
	import AppChartWrapper from "../AppChartWrapper";
	export default {
		name: "TopicCloud",
		props: {
			name: {
				type: String,
                default: "Sentiment Drivers"
            },

			summaryData: {
				type: Object,
                default(){
					return {}
                },
				required: true
			},
			summaryDataReady: {
				type: Boolean,
				required: true
			}
		},
        data(){
			return{
				wordCloudSentimentValues:["positive", "negative", "neutral", "interest"],
            }
        },
		computed: {
			filteredWordCloudData() {
				let initCloud = Object.entries(this.summaryData).map(data => {
					let initDataArray = [data[0]];
					initDataArray[1] = data[1].filter(item => this.wordCloudSentimentValues.includes(item.category));
					return initDataArray;
				});
				initCloud = initCloud.filter(item => item[1].length);
				return Object.fromEntries(initCloud);
			},

			wordsCloudData() {
				const tagsData = this.wordCloudSentimentValues.length < 4 ? this.filteredWordCloudData : this.summaryData;
				const totalTagCount = Object.values(tagsData).flat().map(data => data.count).reduce((acc, cur) => {return acc + cur}, 0);
				const maxFontWeight = 120;
				const data = Object.keys(tagsData ? tagsData : {})
					.map((word) => {
						const sortedCategory = tagsData[word].filter(t => t.category !== 'other')
							.sort((c1, c2) => parseInt(c1.count) - parseInt(c2.count)).reverse()
						const biasCategory = sortedCategory[0]
						let weight = sortedCategory.map(sc => parseInt(sc.count))
							.reduce((a, b) => a + b, 0)
						weight = Math.floor((weight / totalTagCount) * maxFontWeight);
						weight = weight < 2 ? 2 : weight;
						return {
							text: word,
							weight,
							category: biasCategory.category
						}
					});
				return {
					data
				}
			},
		},
		components: {
			AppChartWrapper,
			TopicCloudCustomFilter,
			[VueWordCloud.name]: VueWordCloud,
		}
	}


</script>

<style scoped>

</style>
